import { produce } from 'immer';

import {
  getApplications,
  createApplication,
  updateApplication,
  deleteApplication,
  getUsersByRole,
  getApplicationRoles,
  getApplicationPermissions,
  selectedApplication,
} from './actions';

export const initialState = {
  applications: {
    loading: false,
    loaded: false,
    error: null,
    list: [],
  },

  createApplication: {
    loading: false,
    loaded: false,
    error: null,
  },

  updateApplication: {
    loading: false,
    loaded: false,
    error: null,
  },

  deleteApplication: {
    loading: false,
    loaded: false,
    error: null,
  },

  usersByRole: {
    loading: false,
    loaded: false,
    error: null,
    data: null,
  },

  applicationRoles: {
    loading: false,
    loaded: false,
    error: null,
    data: null,
  },

  applicationPermissions: {
    loading: false,
    loaded: false,
    error: null,
    data: null,
  },

  selectedApplication: {
    error: null,
    app: '',
  },
};

const reducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case getApplications.REQUEST:
        draft.applications.loading = true;
        draft.applications.loaded = false;
        draft.applications.error = null;
        break;

      case getApplications.SUCCESS:
        draft.applications.loading = false;
        draft.applications.loaded = true;
        draft.applications.error = null;
        draft.applications.list = payload;
        break;

      case getApplications.FAILURE:
        draft.applications.loading = false;
        draft.applications.loaded = false;
        draft.applications.error = payload;
        break;

      case createApplication.REQUEST:
        draft.createApplication.loading = true;
        draft.createApplication.loaded = false;
        draft.createApplication.error = null;
        break;

      case createApplication.SUCCESS:
        draft.createApplication.loading = false;
        draft.createApplication.loaded = true;
        draft.createApplication.error = null;
        break;

      case createApplication.FAILURE:
        draft.createApplication.loading = false;
        draft.createApplication.loaded = false;
        draft.createApplication.error = payload;
        break;

      case createApplication.RESET:
        draft.createApplication = { ...initialState.createApplication };
        break;

      case updateApplication.REQUEST:
        draft.updateApplication.loading = true;
        draft.updateApplication.loaded = false;
        draft.updateApplication.error = null;
        break;

      case updateApplication.SUCCESS:
        draft.updateApplication.loading = false;
        draft.updateApplication.loaded = true;
        break;

      case updateApplication.FAILURE:
        draft.updateApplication.loading = false;
        draft.updateApplication.loaded = false;
        draft.updateApplication.error = payload;
        break;

      case updateApplication.RESET:
        draft.updateApplication = { ...initialState.updateApplication };
        break;

      case deleteApplication.REQUEST:
        draft.deleteApplication.loading = true;
        draft.deleteApplication.loaded = false;
        draft.deleteApplication.error = null;
        break;

      case deleteApplication.SUCCESS:
        draft.deleteApplication.loading = false;
        draft.deleteApplication.loaded = true;
        draft.deleteApplication.error = null;
        break;

      case deleteApplication.FAILURE:
        draft.deleteApplication.loading = false;
        draft.deleteApplication.loaded = false;
        draft.deleteApplication.error = payload;
        break;

      case deleteApplication.RESET:
        draft.deleteApplication = { ...initialState.deleteApplication };
        break;

      case getUsersByRole.REQUEST:
        draft.usersByRole.loading = true;
        draft.usersByRole.loaded = false;
        draft.usersByRole.error = null;
        draft.usersByRole.data = null;
        break;

      case getUsersByRole.SUCCESS:
        draft.usersByRole.loading = false;
        draft.usersByRole.loaded = true;
        draft.usersByRole.data = payload;
        break;

      case getUsersByRole.FAILURE:
        draft.usersByRole.loading = false;
        draft.usersByRole.loaded = false;
        draft.usersByRole.error = payload;
        break;

      case getUsersByRole.RESET:
        draft.usersByRole = { ...initialState.usersByRole };
        break;

      case getApplicationRoles.REQUEST:
        draft.applicationRoles.loading = true;
        draft.applicationRoles.loaded = false;
        draft.applicationRoles.error = null;
        draft.applicationRoles.data = null;
        break;

      case getApplicationRoles.SUCCESS:
        draft.applicationRoles.loading = false;
        draft.applicationRoles.loaded = true;
        draft.applicationRoles.data = payload;
        break;

      case getApplicationRoles.FAILURE:
        draft.applicationRoles.loading = false;
        draft.applicationRoles.loaded = false;
        draft.applicationRoles.error = payload;
        break;

      case getApplicationRoles.RESET:
        draft.applicationRoles = { ...initialState.applicationRoles };
        break;

      case getApplicationPermissions.REQUEST:
        draft.applicationPermissions.loading = true;
        draft.applicationPermissions.loaded = false;
        draft.applicationPermissions.error = null;
        draft.applicationPermissions.data = null;
        break;

      case getApplicationPermissions.SUCCESS:
        draft.applicationPermissions.loading = false;
        draft.applicationPermissions.loaded = true;
        draft.applicationPermissions.data = payload;
        break;

      case getApplicationPermissions.FAILURE:
        draft.applicationPermissions.loading = false;
        draft.applicationPermissions.loaded = false;
        draft.applicationPermissions.error = payload;
        break;

      case getApplicationPermissions.RESET:
        draft.applicationPermissions = { ...initialState.applicationPermissions };
        break;

      case selectedApplication.SUCCESS:
        draft.selectedApplication.error = false;
        draft.selectedApplication.app = payload;
        break;

      case selectedApplication.FAILURE:
        draft.selectedApplication.error = payload;
        break;

      case selectedApplication.RESET:
        draft.selectedApplication = { ...initialState.selectedApplication };
        break;

      default:
        return draft;
    }
  });

export default reducer;
